<template>
  <div class="m_contact">
    <mNav></mNav>

    <div class="show_image">
      <div class="show_image_container">
        <img src="@/assets/imgs/b12.png" alt="" />
      </div>
    </div>
    <div class="info-message">
      <div class="one">
        <div class="icon">
          <img
            src="@/assets/imgs/address.png"
            style="width: 0.21rem; height: 0.26rem"
            alt=""
          />
        </div>
        <div class="info-text">
          <div class="info-text-title">地址：</div>
          <div class="info-text-content">{{footerData.address}}</div>
        </div>
      </div>
      <div class="one">
        <div class="icon">
          <img src="@/assets/imgs/address.png" alt="" />
        </div>
        <div class="info-text">
          <div class="info-text-title">电话：</div>
          <div class="info-text-content">{{footerData.tel}}</div>
        </div>
      </div>
      <div class="one">
        <div class="icon">
          <img src="@/assets/imgs/address.png" alt="" />
        </div>
        <div class="info-text">
          <div class="info-text-title">手机：</div>
          <div class="info-text-content">{{footerData.time}}</div>
        </div>
      </div>
      <div class="one">
        <div class="icon">
          <img src="@/assets/imgs/address.png" alt="" />
        </div>
        <div class="info-text">
          <div class="info-text-title">邮箱：</div>
          <div class="info-text-content">{{footerData.email}}</div>
        </div>
      </div>
    </div>
    <mFooter></mFooter>
  </div>
</template>
    <script>
import mNav from "@/components/m/Nav";
import mFooter from "@/components/m/Footer";
export default {
  name: "mIndex",
  components: {
    mNav,
    mFooter,
  },
  metaInfo: {
    title: "洋宇集团有限公司",
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=yes",
      },
    ],
  },
  data() {
    return {
      footerData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(this.$host + "/api/index/contact")
        .then((res) => {
          this.footerData = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
  <style scoped>
.show_iamge {
  width: 100%;
}
.show_image .show_image_container {
  width: 100%;
  padding: 0.6rem 0.35rem 0.35rem 0.35rem;
}

.show_image img {
  width: calc(100% - 0.7rem);
}

.info-message {
  width: 100%;
  padding-bottom: 0.6rem;
}
.info-message .one {
  display: flex;
  padding: 0 0.3rem;
  margin-top: 0.2rem;
}

.info-message .one .icon {
  width: 0.21rem;
  margin-right: 0.27rem;
  margin-top: 0.1rem;
}

.info-message .one .info-text .info-text-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.info-message .one .info-text .info-text-content {
  font-size: 14px;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/page/m/Contact.vue